import { createBrowserRouter, Navigate, useParams } from 'react-router';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './lib/session';
import { InvitePage } from './routes/Invite';
import { OnboardingPage } from './routes/Onboarding';
import { SignInPage } from './routes/SignIn';
import { TasksPage } from './routes/Tasks';
import { TwoPage } from './routes/Two';
import { YouIndex, YouLayout, YouSection } from './routes/You';

/** /settings/:section → /you/:section */
function SettingsRedirect() {
  const { section } = useParams();
  return <Navigate to={section ? `/you/${section}` : '/you'} replace />;
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/two" replace /> },
      { path: 'signin', element: <SignInPage /> },
      { path: 'invite/:code', element: <InvitePage /> },
      {
        path: 'onboarding',
        element: (
          <RequireAuth allowUnonboarded>
            <OnboardingPage />
          </RequireAuth>
        ),
      },
      {
        path: 'two',
        element: (
          <RequireAuth>
            <TwoPage />
          </RequireAuth>
        ),
      },
      { path: 'chat', element: <Navigate to="/two" replace /> },
      {
        path: 'tasks',
        element: (
          <RequireAuth>
            <TasksPage />
          </RequireAuth>
        ),
      },
      {
        path: 'you',
        element: (
          <RequireAuth>
            <YouLayout />
          </RequireAuth>
        ),
        children: [
          { index: true, element: <YouIndex /> },
          { path: ':section', element: <YouSection /> },
        ],
      },
      { path: 'settings', element: <Navigate to="/you" replace /> },
      { path: 'settings/:section', element: <SettingsRedirect /> },
      { path: '*', element: <Navigate to="/two" replace /> },
    ],
  },
]);
